/**
 * Who settles with the supplier.
 *
 * Two values and, wherever either is shown, the same two colours: the tabs
 * on the order form and the rows in the orders table. Kept in one place
 * rather than at each end, so the green on a row and the green on the tab
 * cannot drift apart.
 *
 * `tone` is a palette entry, not a colour, because the table tints a row
 * with it and the tab paints text and a border with it - and those have to
 * come out of the same theme.
 */
const PAY_TYPES = [
  {
    value: "customer_pay",
    label: "Customer Pay",
    note: "the customer pays the supplier",
    tone: "success",
  },
  {
    value: "we_pay",
    label: "We Pay",
    note: "we pay the supplier",
    tone: "info",
  },
];

/**
 * The type a stored value stands for, or null.
 *
 * Read loosely: the column is nullable and plenty of orders predate the
 * field, so "not set" is an ordinary answer rather than a fault.
 */
export const payTypeOf = (value) => {
  const v = String(value ?? "")
    .trim()
    .toLowerCase();

  return PAY_TYPES.find((p) => p.value === v) || null;
};

export default PAY_TYPES;
